<template>
  <div class="multi-select-drop-down" @click="toggleDropDown()">
    <div class="select-area">
      <icon size="18" v-if="icon">{{ icon }}</icon>
      <p :class="['selected', { 'with-icon': icon }]">
        {{
          placeholder
            ? `${placeholder} (${selected.length})`
            : selected.length + " selected" || "Choose one"
        }}
      </p>
      <icon :class="[{ rotate: isDropped }]">arrow_drop_down</icon>
    </div>
    <SlideYUpTransition>
      <div
        v-if="isDropped"
        :class="['options', 'shadow-down', { dropup: dropup }]"
      >
        <div
          class="option flex-row-align-center"
          v-for="option in options"
          :key="option.id"
          @click="selectItem($event, option)"
        >
          <icon
            class="mar-right-10"
            :checked="isSelected(option.id) ? 'checked' : ''"
            >{{
              isSelected(option.id) ? "check_box" : "check_box_outline_blank"
            }}</icon
          >
          <p class="ellipsis">{{ option.name }}</p>
          <div class="flex-expand"></div>
          <p class="fc-primary">{{ option.info_type }}</p>
        </div>
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    options: Array,
    value: Array,
    selectAll: Boolean,
    dropup: Boolean,
    icon: String,
    placeholder: String,
  },
  data() {
    return { selected: this.value, isDropped: false };
  },
  methods: {
    toggleDropDown() {
      this.isDropped = !this.isDropped;
    },
    closeDropDown() {
      this.isDropped = false;
    },
    removeListener() {
      this.closeDropDown();
      document.removeEventListener("click", this.removeListener, false);
    },
    selectItem($event, option) {
      // disable the click listener if it is inside the options list
      $event.stopPropagation();
      // remove if the item is already in the selected list
      if (this.isSelected(option.id)) {
        this.selected = this.selected.filter(item => {
          return item.id !== option.id;
        });
      } else {
        this.selected.push(option);
      }
      this.$emit("input", this.selected);
    },
    /**
     * function to check if the item is already selected
     */
    isSelected(id) {
      return this.selected.find(option => {
        return option.id === id;
      })
        ? true
        : false;
    },
  },
  watch: {
    isDropped(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
  mounted() {},
  created() {
    if (this.selectAll) {
      this.selected = this.options;
      this.$emit("input", this.selected);
    }
  },
};
</script>

<style lang="scss" scoped>
.multi-select-drop-down {
  position: relative;
  display: flex;
  flex-direction: column;

  label {
    color: var(--color-primary);
    font-size: 0.8em;
  }

  .select-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: var(--color-default-background);
    transition: 0.2s all ease-in-out;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    padding: 0 10px;
    z-index: 100;

    &:hover {
      border: 1px solid var(--color-accent);
      cursor: pointer;
    }

    i {
      transition: 0.2s transform ease-in-out;
      pointer-events: none;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }

  .selected {
    margin: 0;
    padding: 12px 15px 12px 5px;
    flex: 1;

    &.with-icon {
      padding: 12px 15px 12px 15px;
    }
  }

  .options {
    position: absolute;
    width: 100%;
    background: var(--color-secondary);
    z-index: 99;
    max-height: 300px;
    overflow: auto;
    top: 50px;
    border-radius: 5px;
    border: 1px solid var(--border-color);

    .option {
      padding: 7px 10px;
      border-bottom: 1px solid var(--border-color);

      &:last-child {
        border: 0;
      }

      &:hover {
        background-color: var(--border-color);
        cursor: pointer;
      }

      i {
        pointer-events: none;
      }

      p {
        margin: 0;
      }
    }
  }
}
.dropup {
  top: auto;
  bottom: 50px;
}
</style>
